<!--  -->
<template>
  <page pageDataUrl="/api/pageData/page_news" v-on:paddingData="paddingPageData" :params="{id: this.$route.params.id }"
    :hasbreadcrumbs="true"  defPageTitle="新闻">
    <!-- <div class="crumbs">
      <div class='content'>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item>新闻</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div> -->

    <div class='content'>
      <h1 class="entry-title">新闻</h1>


      <div>
        <div class="newWrap" v-for="(item ,index) in allNews">
          <div class="timeWrap">
            <p>{{formatDate(item.newsDate,'yyyy年MM月dd日')}}</p>
          </div>
          <div class="contentWrap">
            <div>
              <router-link :to="{path:'news/'+item.newsId}">
                <h1 class="newsItemTitle">
                  {{item.newsTitle}}
                </h1>
              </router-link>
            </div>
            <div class="newsItemContent">
              {{item.newsHtml}}
            </div>
          </div>
        </div>

      </div>

      <div v-if="allNews == undefined ||   allNews.length == 0 " style="text-align: center;font-size: 96%;">
          没有更多新闻了
        </div>
    </div>
  </page>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        allNews: []
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      paddingPageData(data) {
        this.allNews = data.data;
      },
      formatDate(longTypeDate, fmt) {
        var date = new Date();
        date.setTime(longTypeDate);
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        let o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds()
        };
        for (let k in o) {
          if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + "";
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1 ? str : this.padLeftZero(str)
            );
          }
        }
        return fmt;
      },
      padLeftZero(str) {
        return ("00" + str).substr(str.length);
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      // var that = this;
      // this.$request.get({
      //   url: "/api/pageData/page_news",
      //   callback: {
      //     success: function(data) {
      //       that.allNews = data.data;
      //     },
      //     err: function(err) {
      //       console.log(err);
      //     }
      //   }
      // });
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style  scoped>
  .newsItemTitle {
    font-size: 105%;
    color: #314478;
    line-height: 1.3;
    padding: 0 0 10px 0;
    text-align: left;
    font-weight: bold;
    text-indent: -1.1em;
    padding-left: 1.1em;
  }

  .newWrap {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 2em;
  }

  .timeWrap p {
    width: 150px;
    text-align: center;
    vertical-align: middle;
    padding: 0;
    font-size: 95%;
    background: #b0bec5;
    color: #fff;
    font-weight: bold;
    border-radius: 5px;
    line-height: 1.4;
  }

  .contentWrap {
    width: calc(100% - 170px);
  }
</style>